<template>
	<svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
		<path d="M27.7912 9.96094L35.5157 18.2634L22.5761 33.6565L8.51349 18.5384L16.6547 9.96094H27.7912Z" fill="#E5F6FD" stroke="#0074B5" stroke-width="1.5"/>
	</svg>
</template>
